export const MAX_VISIBLE_SUBJECTS = 18

export const PRIMARY_SUBJECTS = [
  'DIREITO À EDUCAÇÃO',
  'DIREITO ADMINISTRATIVO E OUTRAS MATÉRIAS DE DIREITO PÚBLICO',
  'DIREITO AMBIENTAL',
  'DIREITO ASSISTENCIAL',
  'DIREITO CIVIL',
  'DIREITO DA CRIANÇA E DO ADOLESCENTE',
  'DIREITO DA SAÚDE',
  'DIREITO DO CONSUMIDOR',
  'DIREITO DO TRABALHO',
  'DIREITO ELEITORAL',
  'DIREITO ELEITORAL E PROCESSO ELEITORAL DO STF',
  'DIREITO INTERNACIONAL',
  'DIREITO MARÍTIMO',
  'DIREITO PENAL',
  'DIREITO PENAL MILITAR',
  'DIREITO PREVIDENCIÁRIO',
  'DIREITO PROCESSUAL CIVIL E DO TRABALHO',
  'DIREITO PROCESSUAL PENAL',
  'DIREITO PROCESSUAL PENAL MILITAR',
  'DIREITO TRIBUTÁRIO',
  'QUESTÕES DE ALTA COMPLEXIDADE, GRANDE IMPACTO E REPERCUSSÃO',
  'REGISTROS PÚBLICOS',
] as const
